<section class="login-page">
  <div class="login-panel">
    <div class="login-copy">
      <span class="eyebrow">Angular Demo Suite</span>
      <h1>Sign in to continue</h1>
      <p>Use the seeded demo account to access the dashboard and local-storage-backed CRUD pages.</p>
    </div>

    <form class="login-form" (ngSubmit)="login()">
      <label>
        <span>Email</span>
        <input
          type="email"
          name="email"
          [(ngModel)]="email"
          required
        />
      </label>

      <label>
        <span>Password</span>
        <input
          type="password"
          name="password"
          [(ngModel)]="password"
          required
        />
      </label>

      <p class="error-message" *ngIf="errorMessage">{{ errorMessage }}</p>

      <button type="submit">Login</button>
    </form>

    <div class="credential-hint">
      <strong>Demo credentials</strong>
      <span>Email: {{ credentials.email }}</span>
      <span>Password: {{ credentials.password }}</span>
    </div>
  </div>
</section>